import ColumnLayout from '../columnLayout';
import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Hundred = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <video
        data-fade-in-play={true}
        playsInline
        muted
        preload={true}
        className={styles.video1}
        src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-01.mp4"
        // poster="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-01-cover.jpg"
      ></video>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text22']),
        }}
      ></h1>
      <ColumnLayout className={styles.content}>
        <video
 data-fade-in-play={true}
        playsInline
        muted
        preload={true}
          src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-02.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-02-cover.jpg"
        ></video>

        <div className={styles.textBox}>
          <h5
            data-speed="1.1"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text23']),
            }}
          ></h5>
          <h6
            data-speed="1.1"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text24']),
            }}
          ></h6>
        </div>
      </ColumnLayout>
    </div>
  );
};

export default Hundred;
